const TaxInfo = () => {
  return (
    <>
      <ul className="list-disc text-s-14 font-medium">
        <li className="mb-3">
          If you dont receive HRA, you can now claim up to &nbsp;
          <span className="font-bold text-s-14">
            ₹60,000 deduction under Section 80GG.
          </span>
        </li>
        <li>
          <div>
            <a
              href="https://cleartax.in/paytax/taxcalculator"
              target="__blank"
              className="text-[#314259] underline hover:text-blue-350 hover:underline cursor-pointer"
            >
              Click here
            </a>
            &nbsp;to calculate your tax as per Budget 2024.
          </div>
        </li>
      </ul>
    </>
  );
};

const HraDescription = () => {
  return (
    <div>
      You can claim HRA while tax filing even if you have not submitted rent
      receipts to your HR.
      <a
        href="https://cleartax.in/income-tax-efiling"
        className="text-base font-bold text-[#1572ED] cursor-pointer"
        target="__blank"
      >
        &nbsp;Cleartax
      </a>
      &nbsp;will help you claim this while e-filing.
    </div>
  );
};
export const componentMap: { [key: string]: () => JSX.Element } = {
  TaxInfo: TaxInfo,
  HraDescription: HraDescription,
};

export const transformToEmailForm = (
  title: string,
  calculatedResult: Record<string, string | number>,
  formData: Record<string, string | number>
) => {
  if (title === 'HRA-Calculator') {
    const percentSalary =
      formData.metroCity === 'Yes'
        ? calculatedResult?.fiftypercentOfBasicSalary || ''
        : calculatedResult?.fortypercentOfBasicSalary || '';
    const hraMapping = {
      isMetroPolitanCity: formData?.metroCity || '',
      hraReceived: calculatedResult?.actualHRA || '',
      percentOfSalary: percentSalary,
      excessOfRentPaid: calculatedResult?.excessRent || '',
      exemptedHra: calculatedResult?.exemptedHra || '',
      totalHraChargeable: calculatedResult?.hraChargeable || '',
    };
    return hraMapping;
  } else {
    return calculatedResult;
  }
};
